import { useState, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import Modal from "../../ReusableComponents/Modal";
import Form from "../../ReusableComponents/Form";
import InputField from "../../ReusableComponents/InputField";
import { addressValidation, emailValidation, nameValidation, phoneNumValidation } from "../../utils/inputValidations";
import InputError from "../../ReusableComponents/InputError";
import { Button } from "../../Components/Helper";
import SelectField from "../../ReusableComponents/SelectField";
import { selectFieldValidation } from "../../utils/inputValidations";
import { postCallingHistory, updateCallingHistory } from "../../apis/BhuMeetTeams/Telecaller/callingHistory";
import TextAreaField from "../../ReusableComponents/TextAreaInput";
import { set } from "lodash";
import { useNavigate } from "react-router";
import { getTelecallerTeams } from "../../apis/adminAPIs/teams";
import { postRequestIssue } from "../../apis/BhuMeetTeams/Oparations/requestIssue";
import Popup from "../../ReusableFunctions/Popup";
import { useSelector } from "react-redux";
import { allIssueTypes } from "../../appConstants";
import { CreateCrmleads, updateCrmleads } from "../../apis/BhuMeetTeams/Crm/leads";
import { getDistricts, getStates, getTalukas } from "../../apis/locations";

export const CreateLeads = ({ existingRequest, open, onClose, data, isEdit }) => {

    const userDetails = useSelector(state => state.user?.user)
    const navigate = useNavigate()

    const { currentHeight, currentWidth } = useWindowSize();

    const [CreateLeadForm, setCreateLeadForm] = useState({
        name: existingRequest?.name || '',
        phone: existingRequest?.phone || '',
        email: existingRequest?.email || '',
        source: existingRequest?.source || '',
        Address: existingRequest?.address || '',
        district: existingRequest?.location?.district || "",
        state: existingRequest?.location?.state || "",
        taluka : existingRequest?.location?.taluka || ""

    });

    const [indianStates, setIndianStates] = useState([]);
    const [StateDistrict, setStateDistrict] = useState([]);
    const [DistrictsLoading, setDistrictsLoading] = useState(false)
    const [StatesLoading, setStatesLoading] = useState(false)
    const [TalukasLoading, setTalukasLoading] = useState(false)
    const [Talukas, setTalukas] = useState([])


    useEffect(() => {

        getStatesFunc()


    }, [])




    const getStatesFunc = async () => {
        try {
            setStatesLoading(true)
            setStateDistrict([])
            setTalukas([])
            const states = await getStates()
            setIndianStates(states?.records)
            setStatesLoading(false)
            if (existingRequest && existingRequest.location.state) {

                let getState = states?.records.find(state => state.state_name_english === existingRequest.location.state)
                if (getState) {
                    setCreateLeadForm((prev) => ({ ...prev, state: { label: getState?.state_name_english, value: getState?.state_code } }))
                    getDistrictsFunc(getState?.state_code)
                }else{
                    existingRequest.location.state = ""
                }

            }
        } catch (err) {
            setStatesLoading(false)
            console.log(err);
            Popup.alert("Error", err.errorMessage, "ERROR");
        }
    }


    const getDistrictsFunc = async (statecode, stateName) => {
        try {
            setDistrictsLoading(true)
            setTalukas([])
            const districts = await getDistricts(statecode, stateName)
            setStateDistrict(districts?.records)
            setDistrictsLoading(false)
            if (existingRequest) {
                let getDistricts = districts?.records.find(state => state.district_name_english === existingRequest.location.district)
                console.log(getDistricts)
                if (!CreateLeadForm.state) {
                    setCreateLeadForm((prev) => ({ ...prev, district: { label: getDistricts?.district_name_english, value: getDistricts?.district_code }, state: { label: getDistricts?.state_name_english, value: getDistricts?.state_code } }))

                } else {
                    setCreateLeadForm((prev) => ({ ...prev, district: { label: getDistricts?.district_name_english, value: getDistricts?.district_code } }))

                }

            }
        } catch (err) {
            setDistrictsLoading(false)
            console.log(err);
            Popup.alert("Error", err.errorMessage, "ERROR");
        }
    }


    const getTalukasFunc = async (districtCode, districtName) => {
        try {
          setTalukasLoading(true)
          const talukas = await getTalukas(districtCode, districtName)
          setTalukas(talukas?.records)
          setTalukasLoading(false)
        } catch (err) {
          setTalukasLoading(false)
          console.log(err);
          Popup.alert("Error", err.errorMessage, "ERROR");
        }
      }

    return (
        <Modal
            header={existingRequest ? "Update Lead" : "Create Lead"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "640px", height: "auto", borderRadius: "10px" }}
        >

            <Form
                onSubmitForm={async (form) => {
                    console.log("subbmit")
                    let formdata = new FormData()
                    console.log(CreateLeadForm)
                    let finalData = {
                        ...CreateLeadForm, // Spread existing properties
                        location: JSON.stringify({
                            district: CreateLeadForm.district?.label || CreateLeadForm.district || "",
                            state: CreateLeadForm.state?.label || CreateLeadForm.state || "",
                            taluka: CreateLeadForm.taluka?.label || CreateLeadForm.taluka || ""
                        })
                    };

                    // Remove the old `city` and `state` keys
                    delete finalData.state;
                    delete finalData.district;
                    for (let key in finalData) {
                        if (finalData.hasOwnProperty(key)) {  // Check if the property is directly on the object
                            formdata.append(key, finalData[key]);
                        }
                    }

                    try {
                        console.log(formdata)
                        if (existingRequest) {
                            formdata.append("id", existingRequest.id)
                            let update = await updateCrmleads({ ...finalData, id: existingRequest.id, previous_Phone: existingRequest.phone })
                            Popup.alert("SUCCESS", update, "SUCCESS")


                        } else {
                            let postform = await CreateCrmleads(formdata)

                            Popup.alert("SUCCESS", postform, "SUCCESS")
                        }

                        return onClose()
                    } catch (error) {
                        return Popup.alert("ERROR", error, "ERROR")
                    }

                }}
                initialValues={CreateLeadForm}
            >
                {(onsubmit) => (
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: currentHeight < 695 ? "5px" : "10px",
                        padding: currentHeight < 695 ? "15px 20px" : "20px",
                        alignItems: "center",
                    }}>

                        <InputField
                            type={"text"}
                            id={"name"}
                            placeholder={"Enter Full Name"}
                            label={"Full Name"}
                            value={CreateLeadForm.name}
                            defaultValue={CreateLeadForm.name}
                            handleChange={(data) => {
                                console.log(data)
                                setCreateLeadForm((prev) => ({ ...prev, name: data }))
                            }}
                            name={"name"}
                            // containerStyle={{ top: callHistory.prevStatus == 'Completed' ? "-23px" : "-3px" }}
                            validation={nameValidation}

                        />

                        <InputField
                            type={"text"}
                            id={"phone"}
                            placeholder={"Enter phone Number"}
                            label={"Mobile Number"}
                            value={CreateLeadForm.phone}
                            defaultValue={CreateLeadForm.phone}
                            handleChange={(data) => {
                                console.log(data)
                                setCreateLeadForm((prev) => ({ ...prev, phone: data }))
                            }}
                            name={"phone"}
                            // containerStyle={{ top: callHistory.prevStatus == 'Completed' ? "-23px" : "-3px" }}
                            validation={phoneNumValidation}

                        />

                        <InputField
                            type={"text"}
                            id={"email"}
                            placeholder={"Enter email"}
                            label={"Email"}
                            value={CreateLeadForm.email}
                            defaultValue={CreateLeadForm.email}
                            handleChange={(data) => {
                                console.log(data)
                                setCreateLeadForm((prev) => ({ ...prev, email: data }))
                            }}
                            name={"email"}
                            // containerStyle={{ top: callHistory.prevStatus == 'Completed' ? "-23px" : "-3px" }}
                            // validation={emailValidation}

                        />

                        <SelectField
                            handleChange={(selectedOption) => setCreateLeadForm((prev) => ({ ...prev, source: selectedOption.value }))}
                            name="source"
                            label="Source"
                            list={[{ label: "Event", value: "Event" }, { label: "Advertise", value: "Advertise" }, { label: "Other", value: "Other" }
                            ]}
                            styles={{ width: "100%", height: "18px", fontSize: "13px" }}
                            validation={selectFieldValidation}
                            defaultValue={{ label: CreateLeadForm.source, value: CreateLeadForm.source }}
                            value={{ label: CreateLeadForm.source, value: CreateLeadForm.source }}
                            containerStyle={{ width: "100%", minHeight: "80px" }}
                        />

                        <InputField
                            type="text"
                            id="Address"
                            placeholder="Enter Address"
                            label="Address"
                            value={CreateLeadForm.Address || ""} // Ensure no crash if location is undefined
                            handleChange={(data) => { // Change "handleChange" to "onChange" if it's a standard input field
                                console.log(data)
                                if (data != undefined) {
                                    setCreateLeadForm((prev) => ({
                                        ...prev, Address: data
                                    }));
                                }
                            }}
                            validation={addressValidation}
                            name="Address"
                            // validation={{
                            //     required: true,
                            //     message: "Required"
                            // }}
                        />



                        {(existingRequest && !existingRequest.location.state) ?
                            <>
                                <InputField
                                    type="text"
                                    id="state"
                                    placeholder="Enter State"
                                    label="State"
                                    value={CreateLeadForm.state || ""} // Ensure no crash if location is undefined
                                    handleChange={(data) => { // Change "handleChange" to "onChange" if it's a standard input field
                                        if (data != undefined) {
                                            setCreateLeadForm((prev) => ({
                                                ...prev, 
                                                state: data,
                                            }));
                                        }
                                    }}
                                    name="state"
                                    // validation={{
                                    //     required: true,
                                    //     message: "Required"
                                    // }}
                                />

                                <InputField
                                    type="text"
                                    id="district"
                                    placeholder="Enter district"
                                    label="District"
                                    value={CreateLeadForm.district || ""} // Ensure no crash if location is undefined
                                    handleChange={(data) => { // Change "handleChange" to "onChange" if it's a standard input field
                                        console.log(data)
                                        if (data != undefined) {
                                            setCreateLeadForm((prev) => ({
                                                ...prev, district: data
                                            }));
                                        }
                                    }}
                                    name="district"
                                    // validation={{
                                    //     required: true,
                                    //     message: "Required"
                                    // }}
                                />

                                <InputField
                                    type="text"
                                    id="taluka"
                                    placeholder="Enter Taluka"
                                    label="Taluka"
                                    value={CreateLeadForm.taluka || ""} // Ensure no crash if location is undefined
                                    handleChange={(data) => { // Change "handleChange" to "onChange" if it's a standard input field
                                        console.log(data)
                                        if (data != undefined) {
                                            setCreateLeadForm((prev) => ({
                                                ...prev, taluka: data
                                            }));
                                        }
                                    }}
                                    name="taluka"
                                    // validation={{
                                    //     required: true,
                                    //     message: "Required"
                                    // }}
                                />
                            </> :

                            <>
                                <SelectField
                                    name={"state"}
                                    label={"State"}
                                    isLoading={StatesLoading}
                                    isDisabled={StatesLoading}
                                    list={indianStates?.map(state => ({ label: state.state_name_english, value: state.state_code }))}
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                                    // validation={selectFieldValidation}
                                    defaultValue={CreateLeadForm.state}

                                    handleChange={(state) => {
                                        console.log(state)
                                        if (state?.value && typeof state?.value == "number") {
                                            getDistrictsFunc(state?.value)
                                            setCreateLeadForm((prev) => ({
                                                ...prev, 
                                                state: state,
                                                district:undefined,
                                                taluka:undefined
                                            }));
                                        }

                                    }}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px"
                                    }}
                                    isSearchable={true}
                                />

                                <SelectField
                                    name={"district"}
                                    label={"District"}
                                    isLoading={DistrictsLoading}
                                    isDisabled={DistrictsLoading}
                                    list={StateDistrict?.map(state => ({ label: state.district_name_english, value: state.district_code }))}
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                                    // validation={selectFieldValidation}
                                    handleChange={(dist) => {
                                        setCreateLeadForm((prev) => ({
                                            ...prev, 
                                            district: dist,
                                            taluka:undefined
                                        }));
                                        getTalukasFunc(undefined,dist?.label)

                                    }}
                                    defaultValue={
                                        StateDistrict?.district
                                    }
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px"
                                    }}
                                    isSearchable={true}
                                />


                                <SelectField
                                    name={"taluka"}
                                    label={"Taluka"}
                                    isLoading={TalukasLoading}
                                    isDisabled={TalukasLoading}
                                    list={Talukas?.map((t) => ({
                                        value: t?.subdistrict_name_english,
                                        label: t?.subdistrict_name_english,
                                      }))}
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                                    // validation={selectFieldValidation}
                                    handleChange={(dist) => {
                                        setCreateLeadForm((prev) => ({
                                            ...prev, taluka: dist
                                        }));

                                    }}
                                    defaultValue={
                                        StateDistrict?.taluka
                                    }
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px"
                                    }}
                                    isSearchable={true}
                                />

                            </>



                        }








                        {/* Buttons (Spanning two columns) */}
                        <div style={{
                            gridColumn: "span 2", // Spanning full width
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            padding: currentHeight < 695 ? "10px" : "20px",
                            height: "70px",
                        }}>
                            <Button isDisabled={false} text={existingRequest ? "Update" : "Add"} onClick={onsubmit} className="btn-large" />
                            <Button text="Cancel" onClick={onClose} className="btn-large lg-cancel-btn" isBtnNotActive={true} />
                        </div>
                    </div>

                )}
            </Form>


        </Modal>
    )
}